const getStyles = () => {
  return {
    // Main Section
    section: {
      padding: '96px 16px',
      position: 'relative',
      overflow: 'hidden',
      '@media (max-width: 640px)': {
        paddingLeft: '24px',
        paddingRight: '24px'
      },
      '@media (max-width: 1024px)': {
        paddingLeft: '32px',
        paddingRight: '32px'
      }
    },
    container: {
      maxWidth: '900px',
      margin: '0 auto'
    },

    // Main CTA Card
    ctaCard: {
      position: 'relative',
      borderRadius: '32px',
      padding: '48px 32px',
      textAlign: 'center',
      overflow: 'hidden',
      background: 'linear-gradient(135deg, #0c5adb 0%, #3a8ef6 100%)',
      boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
      '@media (max-width: 640px)': {
        padding: '64px 48px'
      }
    },

    // Animated Background Elements
    backgroundContainer: {
      position: 'absolute',
      inset: 0,
      overflow: 'hidden'
    },
    animatedCircle1: {
      position: 'absolute',
      top: 0,
      right: 0,
      width: '384px',
      height: '384px',
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      borderRadius: '50%',
      filter: 'blur(48px)'
    },
    animatedCircle2: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '384px',
      height: '384px',
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      borderRadius: '50%',
      filter: 'blur(48px)'
    },
    gradientOverlay1: {
      position: 'absolute',
      inset: 0,
      background:
        'radial-gradient(circle at 30% 20%, rgba(255,255,255,0.15), transparent 50%)'
    },
    gradientOverlay2: {
      position: 'absolute',
      inset: 0,
      background:
        'radial-gradient(circle at 70% 80%, rgba(255,255,255,0.1), transparent 50%)'
    },

    // Content
    content: {
      position: 'relative',
      zIndex: 10
    },
    badge: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      padding: '8px 16px',
      marginBottom: '32px',
      borderRadius: '9999px',
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
      backdropFilter: 'blur(8px)',
      border: '1px solid rgba(255, 255, 255, 0.3)'
    },
    pulseDot: {
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      backgroundColor: '#ffffff',
      animation: 'pulse 2s infinite'
    },
    badgeText: {
      fontSize: '0.875rem',
      fontWeight: 500,
      color: '#ffffff'
    },
    title: {
      fontSize: '45px',
      fontWeight: 'bold',
      color: '#ffffff',
      marginBottom: '24px',
      lineHeight: 1.2,
      '@media (max-width: 426px)': {
        fontSize: '20px'
      }
    },
    subtitle: {
      fontSize: '1.25rem',
      color: 'rgba(255, 255, 255, 0.9)',
      marginBottom: '48px',
      maxWidth: '600px',
      margin: '0 auto 48px',
      lineHeight: 1.6
    },

    // Buttons
    buttonsContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '16px',
      '@media (max-width: 426px)': {
        flexDirection: 'column'
      }
    },
    primaryButton: {
      backgroundColor: '#ffffff',
      color: '#667eea',
      fontWeight: 600,
      padding: '28px 32px',
      fontSize: '14px',
      borderRadius: '16px',
      boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
      transition: 'all 0.3s ease',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        transform: 'scale(1.05)',
        boxShadow: '0 25px 50px -12px rgba(255, 255, 255, 0.2)'
      }
    },
    outlineButton: {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      color: '#ffffff',
      border: '2px solid rgba(255, 255, 255, 0.3)',
      fontWeight: 600,
      padding: '28px 32px',
      fontSize: '14px',
      borderRadius: '16px',
      backdropFilter: 'blur(8px)',
      transition: 'all 0.3s ease',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        borderColor: 'rgba(255, 255, 255, 0.5)',
        transform: 'scale(1.05)'
      }
    },
    buttonIcon: {
      fontSize: '20px',
      marginRight: '8px'
    },

    // Trust Badges
    trustBadges: {
      marginTop: '48px',
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '24px',
      color: 'rgba(255, 255, 255, 0.8)',
      fontSize: '0.875rem'
    },
    trustBadge: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    checkCircle: {
      width: '20px',
      height: '20px',
      borderRadius: '50%',
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '12px',
      fontWeight: 'bold'
    },

    // Animations
    '@keyframes pulse': {
      '0%': {
        opacity: 1,
        transform: 'scale(1)'
      },
      '50%': {
        opacity: 0.5,
        transform: 'scale(0.8)'
      },
      '100%': {
        opacity: 1,
        transform: 'scale(1)'
      }
    }
  };
};

export default getStyles;
